/* global google, APP */

let googleMapsApiInitialized = false;

const googleDefined = callback =>
  typeof google !== 'undefined' ? callback() : setTimeout(() => googleDefined(callback), 100);

export function loadGmapApi(apiKey, callback) {
  googleDefined(callback);
  initializeGmapApiScript(apiKey);
}

function initializeGmapApiScript(apiKey) {
  const tryInit = () => {
    if (!googleMapsApiInitialized) {
      const head = document.getElementsByTagName('head')[0];

      if (head) {
        googleMapsApiInitialized = true;
        const googleMapsApiSrc = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&language=${getLanguageKey()}`;
        const scriptNode = document.createElement('script');
        scriptNode.src = googleMapsApiSrc;
        scriptNode.defer = true;
        scriptNode.async = true;
        head.appendChild(scriptNode);
      } else {
        setTimeout(tryInit, 100);
      }
    }
  };

  tryInit();
}

function getLanguageKey() {
  if (APP.APP_LANGUAGE === 'de') {
    return 'de-DE';
  }

  if (APP.APP_LANGUAGE === 'it') {
    return 'it-IT';
  }

  return 'en-GB';
}
